import actionTypes from '../common/actionTypes';
import quotingAPI from './quotingAPI';

const quotingActions = {
	fetchHeightWeightTable: () => (dispatch: any) => {
		return quotingAPI.fetchHeightWeightTable()
			.then((hwTable: HeightWeight[]) => {
				dispatch({ type: actionTypes.FETCH_HEIGHT_WEIGHT_TABLE, hwTable });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchCustomerDetails: (customerId: string) => (dispatch: any) => {
		return quotingAPI.fetchCustomerDetails(customerId)
			.then((customerDetails: CustomerDemographicDetails) => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_DETAILS, customerDetails });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchCustomerFamilyList: (customerId: string) => (dispatch: any) => {
		return quotingAPI.fetchCustomerFamilyList(customerId)
			.then((customerFamilyList: CustomerFamily[]) => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_FAMILY_LIST, customerFamilyList });
			})
			.catch(err => {
				throw err;
			});
	},
	resetCustomerDetails: () => {
		return { type: actionTypes.RESET_CUSTOMER_DETAILS };
	},
	setCustomerDetails: (customerDetails: CustomerDemographicDetails) => {
		return { type: actionTypes.SET_CUSTOMER_DETAILS, customerDetails };
	},
	setCustomerFamilyList: (customerFamilyList: CustomerFamily[]) => {
		return { type: actionTypes.SET_CUSTOMER_FAMILY_LIST, customerFamilyList };
	},
	setQuotingAssessment: (assessment: any) => {
		return { type: actionTypes.SET_QUOTING_ASSESSMENT, assessment };
	},
	saveCustomerDetails: (customerDetails: CustomerDemographicDetails) => (dispatch: any) => {
		return quotingAPI.saveCustomerDetails(customerDetails)
			.then((savedCustomerDetails: CustomerDemographicDetails) => {
				dispatch({ type: actionTypes.SAVE_CUSTOMER_DETAILS, customerDetails: savedCustomerDetails });
			})
			.catch(err => {
				throw err;
			});
	},
	saveCustomerFamilyList: (customerId: string, customerFamilyList: CustomerFamily[]) => (dispatch: any) => {
		return quotingAPI.saveCustomerFamilyList(customerId, customerFamilyList)
			.then((savedCustomerFamilyList: CustomerFamily[]) => {
				dispatch({ type: actionTypes.SAVE_CUSTOMER_FAMILY_LIST, customerFamilyList: savedCustomerFamilyList });
			})
			.catch(err => {
				throw err;
			});
	},
	validateReferralCode: (referralCode: string, userId: number) => (dispatch: any) => {
		return quotingAPI.validateReferralCode(referralCode, userId)
			.then((validReferral: boolean) => {
				dispatch({ type: actionTypes.VALIDATE_REFERRALCODE_SUCCESS, validReferral });
			})
			.catch(err => {
				throw err;
			});
	},
};

export default quotingActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/quotingActions.ts